import { Button, TextField } from "@mui/material";
import React from "react";
import { useFormik } from "formik";
import { BankDetailsType } from "../../../types/sellerType";
import { useAppDispatch } from "../../../State/Store";
import { updateSellerAccount } from "../../../State/seller/sellerSlice";
import * as Yup from "yup";
import {
  finnishIBANRegex,
  finnishIFSCRegex,
} from "../../../customer/pages/Become Seller/SellerAccountForm";
interface BankDetailsProp {
  bankDetails: BankDetailsType | undefined;
}
const BankAccountEditFormSchema = Yup.object().shape({
  accountNumber: Yup.string()
    .required("Account Number is required")
    .matches(
      finnishIBANRegex,
      "Account Number must be a valid Finnish IBAN (e.g., FI followed by 16 digits)"
    ),
  ifscCode: Yup.string()
    .required("IFSC Code is required")
    .matches(
      finnishIFSCRegex,
      "IFSC Code must be alphanumeric and meet Finnish requirements"
    ),
  accountHolderName: Yup.string().required("Account Holder Name is required"),
});
export const BankDetails = (data: BankDetailsProp) => {
  const dispatch = useAppDispatch();
  const formik = useFormik({
    initialValues: {
      bankDetails: {
        accountNumber: data.bankDetails?.accountNumber || "",
        ifscCode: data.bankDetails?.ifscCode || "",
        accountHolderName: data.bankDetails?.accountHolderName || "",
      },
    },
    validationSchema:BankAccountEditFormSchema,
    onSubmit: async (values) => {
      //submit form

      await dispatch(updateSellerAccount(values)).unwrap();
    },
  });
  return (
    <form className="space-y-5">
      <TextField
        fullWidth
        name="bankDetails.accountHolderName"
        label="Account Number"
        value={formik.values.bankDetails.accountHolderName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.bankDetails?.accountHolderName &&
          Boolean(formik.errors.bankDetails?.accountHolderName)
        }
        helperText={
          formik.touched.bankDetails?.accountHolderName &&
          formik.errors.bankDetails?.accountHolderName
        }
      />
      <TextField
        fullWidth
        name="bankDetails.accountNumber"
        label="Account Number"
        value={formik.values.bankDetails.accountNumber}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.bankDetails?.accountNumber &&
          Boolean(formik.errors.bankDetails?.accountNumber)
        }
        helperText={
          formik.touched.bankDetails?.accountNumber &&
          formik.errors.bankDetails?.accountNumber
        }
      />
      <TextField
        fullWidth
        name="bankDetails.ifscCode"
        label="IFSC Code"
        value={formik.values.bankDetails.ifscCode}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.bankDetails?.ifscCode &&
          Boolean(formik.errors.bankDetails?.ifscCode)
        }
        helperText={
          formik.touched.bankDetails?.ifscCode &&
          formik.errors.bankDetails?.ifscCode
        }
      />

      <Button
        fullWidth
        variant="contained"
        type="submit"
        onClick={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
      >
        Submit
      </Button>
    </form>
  );
};
